﻿document.addEventListener('DOMContentLoaded', () => {
    const $searchForm = document.getElementById('headerSearch');

    if ($searchForm) {
        const $searchInput = $searchForm.querySelector('.input');
        const $trigger = document.getElementById('search-trigger');

        $trigger.addEventListener('click', (event) => {
            event.preventDefault();
            $searchInput.focus();
        });
    }

});